const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgStandValue(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 500 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Floor--inject-161"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M101.4,390.74c83.79,43.77,219.63,43.77,303.42,0s83.78-114.74,0-158.51-219.63-43.77-303.42,0S17.62,347,101.4,390.74Z",
    style: {
      fill: "#f5f5f5"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Shadow--inject-161"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M424.63,314.79c-12.59,6-33,6-45.61,0s-12.6-15.74,0-21.74,33-6,45.61,0S437.23,308.78,424.63,314.79Z",
    style: {
      fill: "#e0e0e0"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--percentage-symbol--inject-161"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M156.44,203.38c-15.95,9.21-28.87,31.6-28.87,50s12.92,25.87,28.87,16.67,28.87-31.6,28.87-50S172.38,194.17,156.44,203.38ZM154,255.75a13.7,13.7,0,0,1-6.54,2.09c-5.6,0-6.21-6.61-6.21-9.45,0-11.1,8.12-25.15,17.73-30.7a13.59,13.59,0,0,1,6.53-2.09c5.61,0,6.21,6.61,6.21,9.45C171.67,236.14,163.56,250.2,154,255.75Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.26,215.66a6.67,6.67,0,0,0-.8-.06,11.34,11.34,0,0,0-4.08.91,19.1,19.1,0,0,1,.19,2.71c0,11.09-8.12,25.15-17.73,30.69a17.6,17.6,0,0,1-2.45,1.18,10.28,10.28,0,0,0,1.72,4.66,5.1,5.1,0,0,0,4.3,2.09,13.59,13.59,0,0,0,6.54-2.09c9.61-5.55,17.72-19.61,17.72-30.7C171.67,222.35,171.12,216.26,166.26,215.66Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176.81,201.34l-14.32-8.27h0C157.24,190,150,190.42,142,195c-16,9.21-28.87,31.6-28.87,50,0,9.1,3.16,15.51,8.28,18.57l.14.1.08,0,14.12,8.15.07,0a15.24,15.24,0,0,1-5.68-6.34,23.5,23.5,0,0,1-2.17-7.13,33.87,33.87,0,0,1-.4-5.08c0-18.41,12.92-40.8,28.87-50a33.45,33.45,0,0,1,4.6-2.19,23.66,23.66,0,0,1,7.26-1.69,15.18,15.18,0,0,1,8.52,1.84Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "153.6 131.69 140.13 123.91 119.84 135.62 72.75 302.85 86.23 310.63 106.24 299.07 153.6 131.69",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "106.24 299.07 86.23 310.63 133.39 143.36 153.6 131.69 106.24 299.07",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "86.23 310.63 133.39 143.36 119.84 135.62 72.75 302.85 86.23 310.63",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78,176.43c-15.94,9.21-28.87,31.6-28.87,50S62.08,252.31,78,243.11s28.87-31.6,28.87-50S94,167.23,78,176.43ZM75.54,228.8A13.66,13.66,0,0,1,69,230.89c-5.61,0-6.21-6.61-6.21-9.45,0-11.09,8.11-25.15,17.72-30.7a13.59,13.59,0,0,1,6.54-2.09c5.6,0,6.21,6.61,6.21,9.45C93.26,209.19,85.14,223.25,75.54,228.8Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.85,188.71a6.83,6.83,0,0,0-.8-.06,11.25,11.25,0,0,0-4.09.92,19,19,0,0,1,.19,2.7c0,11.09-8.11,25.15-17.72,30.69A18.26,18.26,0,0,1,63,224.14a10.21,10.21,0,0,0,1.73,4.67,5.1,5.1,0,0,0,4.3,2.08,13.66,13.66,0,0,0,6.54-2.09c9.6-5.55,17.72-19.61,17.72-30.7C93.26,195.4,92.7,189.31,87.85,188.71Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.4,174.39l-14.32-8.27h0c-5.23-3.05-12.47-2.63-20.47,2-16,9.2-28.88,31.59-28.88,50,0,9.1,3.17,15.51,8.28,18.57l.14.1.08,0L57.33,245l.08,0a15.23,15.23,0,0,1-5.69-6.33,23.65,23.65,0,0,1-2.17-7.14,33.76,33.76,0,0,1-.4-5.08c0-18.41,12.93-40.8,28.87-50a34.65,34.65,0,0,1,4.6-2.19,23.72,23.72,0,0,1,7.27-1.69,15.16,15.16,0,0,1,8.51,1.84Z",
    style: {
      fill: "#37474f"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--chart-2--inject-161"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M303.45,362.64l9.45,17.85a64.47,64.47,0,0,0,21.42-7.43l-22.85-5.13C309.14,369.26,306.38,362.13,303.45,362.64Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M303.45,362.64l9.45,17.85a64.47,64.47,0,0,0,21.42-7.43l-22.85-5.13C309.14,369.26,306.38,362.13,303.45,362.64Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M284.08,352.09c4.57-2.64,10.83-3.67,16.75-3.13l5.05-29-5.05-9-26.06,3.42-28,41,.87,1.25,30.86,2.24C279,356.39,280.8,354,284.08,352.09Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M284.08,352.09c4.57-2.64,10.83-3.67,16.75-3.13l5.05-29-5.05-9-26.06,3.42-28,41,.87,1.25,30.86,2.24C279,356.39,280.8,354,284.08,352.09Z",
    style: {
      opacity: 0.7000000000000001
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "305.88 300.25 305.88 295.13 300.83 313.51 300.84 318.63 305.88 300.25",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "305.88 300.25 305.88 295.13 300.83 313.51 300.84 318.63 305.88 300.25",
    style: {
      opacity: 0.7000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M284.08,316.64c4.57-2.63,10.83-3.67,16.75-3.13l5.05-18.38c-28.18-2.57-54.64,8.52-59.1,24.79-.13.46-.27,1.09-.35,1.55l32.08,1.95C279,320.94,280.8,318.54,284.08,316.64Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M284.08,316.64c4.57-2.63,10.83-3.67,16.75-3.13l5.05-18.38c-28.18-2.57-54.64,8.52-59.1,24.79-.13.46-.27,1.09-.35,1.55l32.08,1.95C279,320.94,280.8,318.54,284.08,316.64Z",
    style: {
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "278.51 344.33 278.51 323.42 246.43 321.47 246.43 342.38 278.51 344.33",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "278.51 344.33 278.51 323.42 246.43 321.47 246.43 342.38 278.51 344.33",
    style: {
      opacity: 0.8
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M311.5,321.76c3.88,2.25,5.76,5.2,5.65,8.14l32.29.33c.46-15.05-17.81-27.62-43.56-30l-5.05,18.38A26.55,26.55,0,0,1,311.5,321.76Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M311.5,321.76c3.88,2.25,5.76,5.2,5.65,8.14l32.29.33c.46-15.05-17.81-27.62-43.56-30l-5.05,18.38A26.55,26.55,0,0,1,311.5,321.76Z",
    style: {
      fill: "#fff",
      opacity: 0.8
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "317.15 329.9 317.15 352.17 349.44 352.5 349.44 330.23 317.15 329.9",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "317.15 329.9 317.15 352.17 349.44 352.5 349.44 330.23 317.15 329.9",
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M317.16,329.9V352c0-2.86-1.88-5.73-5.66-7.92-3-1.74-6.76,5.29-10.66,4.93V318.63C309.66,319.38,317.32,323.83,317.16,329.9Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M317.16,329.9V352c0-2.86-1.88-5.73-5.66-7.92-3-1.74-6.76,5.29-10.66,4.93V318.63C309.66,319.38,317.32,323.83,317.16,329.9Z",
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 278.41,
    y: 339.82,
    width: 38.76,
    height: 26.06,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M284.08,347.87c-7.57-4.37-7.57-11.46,0-15.83s19.85-4.37,27.42,0,7.56,11.46,0,15.83S291.65,352.24,284.08,347.87Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M317.15,352.17c-.1,2.79-2,13.62-5.65,15.74l0,0,22.85,5.13c10-5.76,14.88-12.41,15.12-20.56Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "349.44 335.11 349.44 352.5 334.32 373.06 334.32 355.68 349.44 335.11",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M317.15,334.78c-.1,2.79-2,5.56-5.65,7.69h0l22.85,13.19c10-5.76,14.88-12.41,15.12-20.56Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "334.32 355.68 334.32 373.06 311.47 359.87 311.5 342.47 334.32 355.68",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "334.32 361.17 312.9 368.6 312.9 380.49 334.32 373.06 334.32 361.17",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "334.32 361.17 312.9 368.6 312.9 380.49 334.32 373.06 334.32 361.17",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M303.45,350.75l9.45,17.85a64.47,64.47,0,0,0,21.42-7.43L311.47,348A24.88,24.88,0,0,1,303.45,350.75Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "303.44 350.75 303.44 356.17 312.9 380.49 312.9 368.6 303.44 350.75",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "303.44 350.75 303.44 356.17 312.9 380.49 312.9 368.6 303.44 350.75",
    style: {
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M288.65,366c-4.28-2.48-10.71-3.87-10.14-7.1l-32.37-15.53s0,7.7,0,8.77c.07,15,19.77,27.93,46.26,29.53a82.83,82.83,0,0,0,20.5-1.14v-8.71C306.27,372.94,293.89,369,288.65,366Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M288.65,366c-4.28-2.48-10.71-3.87-10.14-7.1l-32.37-15.53s0,7.7,0,8.77c.07,15,19.77,27.93,46.26,29.53a82.83,82.83,0,0,0,20.5-1.14v-8.71C306.27,372.94,293.89,369,288.65,366Z",
    style: {
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M284.08,351.14c-4.28-2.47-6.14-5.82-5.57-9.05l-32.08-1.95c-3,16.38,17.6,31.06,46,32.78a83.31,83.31,0,0,0,20.5-1.14l-9.45-17.85C296.82,355.09,289.32,354.17,284.08,351.14Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M284.08,351.14c-4.28-2.47-6.14-5.82-5.57-9.05l-32.08-1.95c-3,16.38,17.6,31.06,46,32.78a83.31,83.31,0,0,0,20.5-1.14l-9.45-17.85C296.82,355.09,289.32,354.17,284.08,351.14Z",
    style: {
      opacity: 0.30000000000000004
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--chart-1--inject-161"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M167,306a48.72,48.72,0,0,0-1.08-18.56c-1.66-6.61-5-11.21-8.95-13.63s-11.14.12-5.4,7.85,11.57,17.57,12.19,25Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.89,306.72h0a.5.5,0,0,1-.49-.51c.28-13.67-6.13-27.42-12-30.58a.5.5,0,0,1,.47-.89c6.17,3.3,12.86,17.47,12.57,31.49A.49.49,0,0,1,165.89,306.72Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.49,330.18c-6.3,3.66-13.46.3-14.7-6.73-.43-2.45-.86-5-3.13-6.39-1.9-1.18-4.46-1.33-6.09-2.91-2.32-2.26-1-5.17.46-7.46,1.36-2.08,2.46-4.51,1.18-6.89a17.25,17.25,0,0,1-1.85-4,4.24,4.24,0,0,1,.91-4.09c1.2-1.14,3.09-1.09,4.7-.7a16.7,16.7,0,0,1,7,3.85c1.41,1.21,2.21,2.44,4.24,2.81,1.5.27,3.06,0,4.54.35a6.78,6.78,0,0,1,4.32,3.57c1.47,2.87,1,6.21.77,9.3s-.52,5.88-.88,8.81c-.3,2.48-.64,5-1,7.43C167.9,327.51,167.83,330,167.49,330.18Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.09,326.72a.5.5,0,0,1-.49-.43c-2.19-15.7-15.41-30.31-20.33-32.82a.5.5,0,1,1,.46-.89c5.21,2.66,18.59,17.29,20.86,33.58a.5.5,0,0,1-.43.56Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.55,309.72a.5.5,0,0,1-.2-1A27.3,27.3,0,0,1,160.82,307a.49.49,0,0,1,.45.54.5.5,0,0,1-.55.45,26.77,26.77,0,0,0-12,1.72A.71.71,0,0,1,148.55,309.72Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.89,333.88a6.81,6.81,0,0,1-3-5.39V177.37a7,7,0,0,1,3.18-5.51L347.66,68.76a6.86,6.86,0,0,1,6.16-.13,6.73,6.73,0,0,1,3,5.36V225.16a7,7,0,0,1-3.18,5.51L175.05,333.77A6.83,6.83,0,0,1,168.89,333.88Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.81,184l-17-9.8a6.46,6.46,0,0,0-.93,3.14V328.49a6,6,0,0,0,9.14,5.28l8.76-5.06Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.81,184l-17-9.8a6.46,6.46,0,0,0-.93,3.14V328.49a6,6,0,0,0,9.14,5.28l8.76-5.06Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.05,175.31,353.62,72.16c1.76-1,3.18-.19,3.18,1.83V225.16a7,7,0,0,1-3.18,5.51L175.05,333.77c-1.75,1-3.17.19-3.17-1.84V180.82A7,7,0,0,1,175.05,175.31Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.5
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M175.05,175.31,353.62,72.16c1.76-1,3.18-.19,3.18,1.83V225.16a7,7,0,0,1-3.18,5.51L175.05,333.77c-1.75,1-3.17.19-3.17-1.84V180.82A7,7,0,0,1,175.05,175.31Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M189.77,297.71a306,306,0,0,1,2.29-32.6c1.39-11.75,4.24-31.58,15.58-38.12s15.59,5.28,17.22,11.11c2.13,7.55,13.21,2.77,14.76-9.69s2.54-52.11,15.82-59.78,17.58,10.79,19.09,15.94c3,10.12,11.7,7.33,14.55.62s10.6-8.34,13.53,1.09,4.75,20.26,14.25,14.7c8.33-4.88,4.5-13.77,12.63-18,2.37-1.22,7.09-.54,8.15,6.42a150.93,150.93,0,0,1,1.27,22.2Z",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189.77,298.45h0a.74.74,0,0,1-.73-.74A308.57,308.57,0,0,1,191.33,265c1.12-9.47,3.75-31.64,15.94-38.68,3.61-2.08,6.87-2.55,9.7-1.4,3.77,1.53,6.58,5.77,8.6,13,.6,2.12,2,3.22,3.93,3.07,3.88-.3,8.45-5.11,9.39-12.65.25-2,.49-4.74.76-7.91,1.48-17.13,4-45.8,15.43-52.42,3.51-2,6.73-2.46,9.59-1.3,6.29,2.55,9,12.1,10.29,16.69.1.37.19.7.28,1,1.11,3.79,3.16,6,5.77,6.11,2.87.19,5.95-2.17,7.39-5.57,1.6-3.77,4.72-6.1,7.84-5.94s5.72,2.74,7.07,7.11c.32,1,.63,2.07.93,3.11,1.67,5.67,3.23,11,6.45,12.3,1.55.61,3.45.24,5.8-1.13,3.92-2.3,5-5.47,6.06-8.83s2.27-6.93,6.6-9.18a5.64,5.64,0,0,1,5.09.06c1.52.77,3.47,2.6,4.12,6.9a152.28,152.28,0,0,1,1.28,22.33.7.7,0,0,1-.75.71.74.74,0,0,1-.72-.75,148.83,148.83,0,0,0-1.26-22.07c-.56-3.69-2.12-5.2-3.33-5.81a4.17,4.17,0,0,0-3.75-.06c-3.8,2-4.81,5.06-5.88,8.33-1.14,3.47-2.32,7.06-6.72,9.64-2.77,1.61-5.08,2-7.08,1.22-3.88-1.54-5.55-7.23-7.32-13.25-.3-1-.6-2.07-.92-3.09-1.16-3.74-3.26-5.95-5.74-6.08s-5.08,1.91-6.42,5.06c-1.7,4-5.32,6.66-8.83,6.46-1.9-.11-5.34-1.19-7.09-7.16-.09-.29-.18-.63-.29-1-1.23-4.36-3.8-13.45-9.43-15.73-2.41-1-5.2-.57-8.3,1.21-10.8,6.24-13.33,35.54-14.69,51.28-.28,3.18-.52,5.93-.77,8-1,8.29-6.27,13.59-10.74,13.93-2.63.2-4.67-1.35-5.45-4.14-1.89-6.71-4.42-10.63-7.75-12-2.38-1-5.21-.53-8.41,1.31-11.55,6.67-14.12,28.33-15.21,37.58a306.87,306.87,0,0,0-2.28,32.51A.74.74,0,0,1,189.77,298.45Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210.91,226.85a.47.47,0,0,1-.47-.47v-.92a.47.47,0,1,1,.93,0v.92A.47.47,0,0,1,210.91,226.85Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210.91,282.34a.47.47,0,0,1-.47-.47V280a.47.47,0,0,1,.93,0v1.85A.47.47,0,0,1,210.91,282.34Zm0-3.7a.47.47,0,0,1-.47-.47v-1.85a.47.47,0,0,1,.93,0v1.85A.47.47,0,0,1,210.91,278.64Zm0-3.7a.47.47,0,0,1-.47-.47v-1.84a.47.47,0,1,1,.93,0v1.84A.47.47,0,0,1,210.91,274.94Zm0-3.7a.47.47,0,0,1-.47-.46v-1.85a.47.47,0,1,1,.93,0v1.85A.47.47,0,0,1,210.91,271.24Zm0-3.7a.47.47,0,0,1-.47-.46v-1.85a.47.47,0,1,1,.93,0v1.85A.47.47,0,0,1,210.91,267.54Zm0-3.7a.47.47,0,0,1-.47-.46v-1.85a.47.47,0,1,1,.93,0v1.85A.47.47,0,0,1,210.91,263.84Zm0-3.7a.47.47,0,0,1-.47-.46v-1.85a.47.47,0,1,1,.93,0v1.85A.47.47,0,0,1,210.91,260.14Zm0-3.7a.46.46,0,0,1-.47-.46v-1.85a.47.47,0,1,1,.93,0V256A.46.46,0,0,1,210.91,256.44Zm0-3.7a.46.46,0,0,1-.47-.46v-1.85a.47.47,0,1,1,.93,0v1.85A.46.46,0,0,1,210.91,252.74Zm0-3.7a.46.46,0,0,1-.47-.46v-1.85a.47.47,0,0,1,.93,0v1.85A.46.46,0,0,1,210.91,249Zm0-3.69a.47.47,0,0,1-.47-.47V243a.47.47,0,0,1,.93,0v1.85A.47.47,0,0,1,210.91,245.35Zm0-3.7a.47.47,0,0,1-.47-.47v-1.85a.47.47,0,0,1,.93,0v1.85A.47.47,0,0,1,210.91,241.65Zm0-3.7a.47.47,0,0,1-.47-.47v-1.85a.47.47,0,0,1,.93,0v1.85A.47.47,0,0,1,210.91,238Zm0-3.7a.47.47,0,0,1-.47-.47v-1.85a.47.47,0,0,1,.93,0v1.85A.47.47,0,0,1,210.91,234.25Zm0-3.7a.47.47,0,0,1-.47-.47v-1.85a.47.47,0,0,1,.93,0v1.85A.47.47,0,0,1,210.91,230.55Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210.91,285.12a.47.47,0,0,1-.47-.47v-.93a.47.47,0,0,1,.93,0v.93A.47.47,0,0,1,210.91,285.12Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M258.89,168.77a.47.47,0,0,1-.46-.46v-.93a.47.47,0,1,1,.93,0v.93A.47.47,0,0,1,258.89,168.77Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M258.89,255.51a.47.47,0,0,1-.46-.47v-1.88a.47.47,0,1,1,.93,0V255A.47.47,0,0,1,258.89,255.51Zm0-3.77a.47.47,0,0,1-.46-.47v-1.89a.47.47,0,0,1,.93,0v1.89A.47.47,0,0,1,258.89,251.74Zm0-3.78a.46.46,0,0,1-.46-.46v-1.89a.47.47,0,0,1,.93,0v1.89A.46.46,0,0,1,258.89,248Zm0-3.77a.47.47,0,0,1-.46-.46v-1.89a.47.47,0,0,1,.93,0v1.89A.47.47,0,0,1,258.89,244.19Zm0-3.77a.47.47,0,0,1-.46-.46v-1.89a.47.47,0,0,1,.93,0V240A.47.47,0,0,1,258.89,240.42Zm0-3.77a.47.47,0,0,1-.46-.46V234.3a.47.47,0,0,1,.93,0v1.89A.47.47,0,0,1,258.89,236.65Zm0-3.77a.47.47,0,0,1-.46-.47v-1.88a.47.47,0,1,1,.93,0v1.88A.47.47,0,0,1,258.89,232.88Zm0-3.77a.47.47,0,0,1-.46-.47v-1.88a.47.47,0,1,1,.93,0v1.88A.47.47,0,0,1,258.89,229.11Zm0-3.77a.47.47,0,0,1-.46-.47V223a.47.47,0,1,1,.93,0v1.88A.47.47,0,0,1,258.89,225.34Zm0-3.77a.47.47,0,0,1-.46-.47v-1.88a.47.47,0,1,1,.93,0v1.88A.47.47,0,0,1,258.89,221.57Zm0-3.77a.47.47,0,0,1-.46-.47v-1.88a.47.47,0,1,1,.93,0v1.88A.47.47,0,0,1,258.89,217.8Zm0-3.78a.46.46,0,0,1-.46-.46v-1.89a.47.47,0,0,1,.93,0v1.89A.46.46,0,0,1,258.89,214Zm0-3.77a.46.46,0,0,1-.46-.46V207.9a.47.47,0,0,1,.93,0v1.89A.46.46,0,0,1,258.89,210.25Zm0-3.77a.47.47,0,0,1-.46-.46v-1.89a.47.47,0,0,1,.93,0V206A.47.47,0,0,1,258.89,206.48Zm0-3.77a.47.47,0,0,1-.46-.46v-1.89a.47.47,0,0,1,.93,0v1.89A.47.47,0,0,1,258.89,202.71Zm0-3.77a.47.47,0,0,1-.46-.46v-1.89a.47.47,0,0,1,.93,0v1.89A.47.47,0,0,1,258.89,198.94Zm0-3.77a.47.47,0,0,1-.46-.47v-1.88a.47.47,0,1,1,.93,0v1.88A.47.47,0,0,1,258.89,195.17Zm0-3.77a.47.47,0,0,1-.46-.47v-1.88a.47.47,0,1,1,.93,0v1.88A.47.47,0,0,1,258.89,191.4Zm0-3.77a.47.47,0,0,1-.46-.47v-1.88a.47.47,0,1,1,.93,0v1.88A.47.47,0,0,1,258.89,187.63Zm0-3.77a.47.47,0,0,1-.46-.47v-1.88a.47.47,0,1,1,.93,0v1.88A.47.47,0,0,1,258.89,183.86Zm0-3.77a.47.47,0,0,1-.46-.47v-1.89a.47.47,0,0,1,.93,0v1.89A.47.47,0,0,1,258.89,180.09Zm0-3.78a.46.46,0,0,1-.46-.46V174a.47.47,0,0,1,.93,0v1.89A.46.46,0,0,1,258.89,176.31Zm0-3.77a.46.46,0,0,1-.46-.46v-1.89a.47.47,0,0,1,.93,0v1.89A.46.46,0,0,1,258.89,172.54Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M258.89,258.32a.47.47,0,0,1-.46-.46v-.93a.47.47,0,1,1,.93,0v.93A.47.47,0,0,1,258.89,258.32Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M295.56,181.42a.47.47,0,0,1-.46-.47V180a.47.47,0,0,1,.93,0V181A.47.47,0,0,1,295.56,181.42Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M295.56,234.48a.47.47,0,0,1-.46-.46v-1.9a.47.47,0,0,1,.93,0V234A.47.47,0,0,1,295.56,234.48Zm0-3.79a.47.47,0,0,1-.46-.46v-1.9a.47.47,0,0,1,.93,0v1.9A.47.47,0,0,1,295.56,230.69Zm0-3.79a.47.47,0,0,1-.46-.46v-1.9a.47.47,0,0,1,.93,0v1.9A.47.47,0,0,1,295.56,226.9Zm0-3.79a.47.47,0,0,1-.46-.46v-1.9a.47.47,0,0,1,.93,0v1.9A.47.47,0,0,1,295.56,223.11Zm0-3.79a.47.47,0,0,1-.46-.46V217a.47.47,0,0,1,.93,0v1.9A.47.47,0,0,1,295.56,219.32Zm0-3.79a.47.47,0,0,1-.46-.46v-1.9a.47.47,0,0,1,.93,0v1.9A.47.47,0,0,1,295.56,215.53Zm0-3.79a.47.47,0,0,1-.46-.46v-1.9a.47.47,0,0,1,.93,0v1.9A.47.47,0,0,1,295.56,211.74Zm0-3.79a.47.47,0,0,1-.46-.46v-1.9a.47.47,0,0,1,.93,0v1.9A.47.47,0,0,1,295.56,208Zm0-3.79a.47.47,0,0,1-.46-.46v-1.9a.47.47,0,0,1,.93,0v1.9A.47.47,0,0,1,295.56,204.16Zm0-3.79a.47.47,0,0,1-.46-.46V198a.47.47,0,0,1,.93,0v1.9A.47.47,0,0,1,295.56,200.37Zm0-3.79a.47.47,0,0,1-.46-.46v-1.9a.47.47,0,0,1,.93,0v1.9A.47.47,0,0,1,295.56,196.58Zm0-3.79a.47.47,0,0,1-.46-.47v-1.89a.47.47,0,1,1,.93,0v1.89A.47.47,0,0,1,295.56,192.79Zm0-3.79a.47.47,0,0,1-.46-.47v-1.89a.47.47,0,1,1,.93,0v1.89A.47.47,0,0,1,295.56,189Zm0-3.79a.47.47,0,0,1-.46-.47v-1.89a.47.47,0,1,1,.93,0v1.89A.47.47,0,0,1,295.56,185.21Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M295.56,237.31a.47.47,0,0,1-.46-.47v-.93a.47.47,0,0,1,.93,0v.93A.47.47,0,0,1,295.56,237.31Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M331.69,183.9a.47.47,0,0,1-.47-.47v-.93a.47.47,0,0,1,.93,0v.93A.47.47,0,0,1,331.69,183.9Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M331.69,213.59a.47.47,0,0,1-.47-.47v-1.85a.47.47,0,1,1,.93,0v1.85A.47.47,0,0,1,331.69,213.59Zm0-3.71a.47.47,0,0,1-.47-.47v-1.85a.47.47,0,1,1,.93,0v1.85A.47.47,0,0,1,331.69,209.88Zm0-3.71a.47.47,0,0,1-.47-.47v-1.85a.47.47,0,1,1,.93,0v1.85A.47.47,0,0,1,331.69,206.17Zm0-3.71a.47.47,0,0,1-.47-.47v-1.86a.47.47,0,0,1,.93,0V202A.47.47,0,0,1,331.69,202.46Zm0-3.72a.46.46,0,0,1-.47-.46v-1.86a.47.47,0,0,1,.93,0v1.86A.46.46,0,0,1,331.69,198.74Zm0-3.71a.47.47,0,0,1-.47-.46v-1.86a.47.47,0,0,1,.93,0v1.86A.47.47,0,0,1,331.69,195Zm0-3.71a.47.47,0,0,1-.47-.46V189a.47.47,0,0,1,.93,0v1.86A.47.47,0,0,1,331.69,191.32Zm0-3.71a.47.47,0,0,1-.47-.46v-1.86a.47.47,0,0,1,.93,0v1.86A.47.47,0,0,1,331.69,187.61Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M331.69,216.37a.46.46,0,0,1-.47-.46V215a.47.47,0,1,1,.93,0v.93A.46.46,0,0,1,331.69,216.37Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M303.11,151.25c0-.91-.64-1.28-1.43-.82L288.51,158a3.18,3.18,0,0,0-1.43,2.49v10.66c0,.91.64,1.28,1.43.82l4.89-2.82,2.05,3.56a.31.31,0,0,0,.56-.06l2.17-6.26h0l3.5-2a3.14,3.14,0,0,0,1.43-2.48Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M291.65,162.42a.87.87,0,0,1-.71-.28,1.26,1.26,0,0,1-.26-.87,2.83,2.83,0,0,1,.26-1.18,4.11,4.11,0,0,1,.71-1.11,3.92,3.92,0,0,1,1-.84,2.06,2.06,0,0,1,1-.31.89.89,0,0,1,.71.29,1.26,1.26,0,0,1,.27.87,2.88,2.88,0,0,1-.27,1.17,4.6,4.6,0,0,1-.71,1.12,4,4,0,0,1-1,.82A2,2,0,0,1,291.65,162.42Zm-.32,5.39a.41.41,0,0,1,.05-.18L297.1,156l.15-.26a1,1,0,0,1,.21-.17l1.17-.67a.18.18,0,0,1,.14,0,.08.08,0,0,1,.06.09.35.35,0,0,1-.06.19L293,166.82c0,.1-.1.17-.13.22a.62.62,0,0,1-.19.14l-1.18.69C291.4,168,291.33,167.93,291.33,167.81Zm2-7.38a1.64,1.64,0,0,0,.29-.88.55.55,0,0,0-.29-.57.81.81,0,0,0-.72.13,2.09,2.09,0,0,0-.72.7,1.68,1.68,0,0,0-.29.9.53.53,0,0,0,.29.55.83.83,0,0,0,.72-.12A2.12,2.12,0,0,0,293.37,160.43Zm3.18,4.48a.88.88,0,0,1-.72-.29,1.23,1.23,0,0,1-.27-.86,2.83,2.83,0,0,1,.27-1.16,4.28,4.28,0,0,1,.72-1.12,3.84,3.84,0,0,1,1-.83,2,2,0,0,1,1-.32.94.94,0,0,1,.72.28,1.24,1.24,0,0,1,.27.87,2.84,2.84,0,0,1-.27,1.17,4.64,4.64,0,0,1-.72,1.12,4.05,4.05,0,0,1-1,.83A2.09,2.09,0,0,1,296.55,164.91Zm1.71-2a1.59,1.59,0,0,0,.29-.89c0-.29-.09-.47-.29-.55a.8.8,0,0,0-.72.13,2,2,0,0,0-.72.7,1.67,1.67,0,0,0-.29.88c0,.3.1.49.29.56a.87.87,0,0,0,.72-.13A2.18,2.18,0,0,0,298.26,162.93Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M291.65,162.42a.87.87,0,0,1-.71-.28,1.26,1.26,0,0,1-.26-.87,2.83,2.83,0,0,1,.26-1.18,4.11,4.11,0,0,1,.71-1.11,3.92,3.92,0,0,1,1-.84,2.06,2.06,0,0,1,1-.31.89.89,0,0,1,.71.29,1.26,1.26,0,0,1,.27.87,2.88,2.88,0,0,1-.27,1.17,4.6,4.6,0,0,1-.71,1.12,4,4,0,0,1-1,.82A2,2,0,0,1,291.65,162.42Zm-.32,5.39a.41.41,0,0,1,.05-.18L297.1,156l.15-.26a1,1,0,0,1,.21-.17l1.17-.67a.18.18,0,0,1,.14,0,.08.08,0,0,1,.06.09.35.35,0,0,1-.06.19L293,166.82c0,.1-.1.17-.13.22a.62.62,0,0,1-.19.14l-1.18.69C291.4,168,291.33,167.93,291.33,167.81Zm2-7.38a1.64,1.64,0,0,0,.29-.88.55.55,0,0,0-.29-.57.81.81,0,0,0-.72.13,2.09,2.09,0,0,0-.72.7,1.68,1.68,0,0,0-.29.9.53.53,0,0,0,.29.55.83.83,0,0,0,.72-.12A2.12,2.12,0,0,0,293.37,160.43Zm3.18,4.48a.88.88,0,0,1-.72-.29,1.23,1.23,0,0,1-.27-.86,2.83,2.83,0,0,1,.27-1.16,4.28,4.28,0,0,1,.72-1.12,3.84,3.84,0,0,1,1-.83,2,2,0,0,1,1-.32.94.94,0,0,1,.72.28,1.24,1.24,0,0,1,.27.87,2.84,2.84,0,0,1-.27,1.17,4.64,4.64,0,0,1-.72,1.12,4.05,4.05,0,0,1-1,.83A2.09,2.09,0,0,1,296.55,164.91Zm1.71-2a1.59,1.59,0,0,0,.29-.89c0-.29-.09-.47-.29-.55a.8.8,0,0,0-.72.13,2,2,0,0,0-.72.7,1.67,1.67,0,0,0-.29.88c0,.3.1.49.29.56a.87.87,0,0,0,.72-.13A2.18,2.18,0,0,0,298.26,162.93Z",
    style: {
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M338.67,153.08c0-.91-.64-1.28-1.43-.83l-13.17,7.62a3.18,3.18,0,0,0-1.43,2.48V173c0,.92.64,1.29,1.43.83L329,171l2.06,3.56a.3.3,0,0,0,.55,0l2.17-6.27h0l3.51-2a3.18,3.18,0,0,0,1.43-2.48Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M327.21,164.25a.9.9,0,0,1-.72-.29,1.26,1.26,0,0,1-.26-.86,3,3,0,0,1,.26-1.18,4.19,4.19,0,0,1,.72-1.12,4.05,4.05,0,0,1,1-.83,2,2,0,0,1,1-.31.88.88,0,0,1,.72.29,1.23,1.23,0,0,1,.27.87,2.83,2.83,0,0,1-.27,1.16,4.28,4.28,0,0,1-.72,1.12,3.84,3.84,0,0,1-1,.83A2,2,0,0,1,327.21,164.25Zm-.33,5.39a.38.38,0,0,1,.06-.19l5.72-11.63a1.19,1.19,0,0,1,.15-.26.69.69,0,0,1,.2-.17l1.18-.68c.06,0,.1-.05.14,0s.05,0,.05.09a.36.36,0,0,1-.05.19l-5.75,11.69a1.27,1.27,0,0,1-.13.22.59.59,0,0,1-.18.14l-1.19.69C327,169.77,326.88,169.75,326.88,169.64Zm2-7.38a1.67,1.67,0,0,0,.29-.88.55.55,0,0,0-.29-.57.81.81,0,0,0-.72.13,2.06,2.06,0,0,0-.71.7,1.6,1.6,0,0,0-.29.9.52.52,0,0,0,.29.55.79.79,0,0,0,.71-.13A2,2,0,0,0,328.92,162.26Zm3.18,4.48a.91.91,0,0,1-.72-.29,1.3,1.3,0,0,1-.26-.86,3,3,0,0,1,.26-1.17,4.64,4.64,0,0,1,.72-1.12,4,4,0,0,1,1-.82,2.07,2.07,0,0,1,1-.32.91.91,0,0,1,.72.28,1.22,1.22,0,0,1,.27.86,2.85,2.85,0,0,1-.27,1.18,4.4,4.4,0,0,1-.72,1.11,3.92,3.92,0,0,1-1,.83A2.12,2.12,0,0,1,332.1,166.74Zm1.72-2a1.68,1.68,0,0,0,.29-.9.54.54,0,0,0-.29-.55.87.87,0,0,0-.73.14,2,2,0,0,0-.71.69,1.63,1.63,0,0,0-.3.89c0,.3.1.48.3.56a.85.85,0,0,0,.71-.13A2.21,2.21,0,0,0,333.82,164.76Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M327.21,164.25a.9.9,0,0,1-.72-.29,1.26,1.26,0,0,1-.26-.86,3,3,0,0,1,.26-1.18,4.19,4.19,0,0,1,.72-1.12,4.05,4.05,0,0,1,1-.83,2,2,0,0,1,1-.31.88.88,0,0,1,.72.29,1.23,1.23,0,0,1,.27.87,2.83,2.83,0,0,1-.27,1.16,4.28,4.28,0,0,1-.72,1.12,3.84,3.84,0,0,1-1,.83A2,2,0,0,1,327.21,164.25Zm-.33,5.39a.38.38,0,0,1,.06-.19l5.72-11.63a1.19,1.19,0,0,1,.15-.26.69.69,0,0,1,.2-.17l1.18-.68c.06,0,.1-.05.14,0s.05,0,.05.09a.36.36,0,0,1-.05.19l-5.75,11.69a1.27,1.27,0,0,1-.13.22.59.59,0,0,1-.18.14l-1.19.69C327,169.77,326.88,169.75,326.88,169.64Zm2-7.38a1.67,1.67,0,0,0,.29-.88.55.55,0,0,0-.29-.57.81.81,0,0,0-.72.13,2.06,2.06,0,0,0-.71.7,1.6,1.6,0,0,0-.29.9.52.52,0,0,0,.29.55.79.79,0,0,0,.71-.13A2,2,0,0,0,328.92,162.26Zm3.18,4.48a.91.91,0,0,1-.72-.29,1.3,1.3,0,0,1-.26-.86,3,3,0,0,1,.26-1.17,4.64,4.64,0,0,1,.72-1.12,4,4,0,0,1,1-.82,2.07,2.07,0,0,1,1-.32.91.91,0,0,1,.72.28,1.22,1.22,0,0,1,.27.86,2.85,2.85,0,0,1-.27,1.18,4.4,4.4,0,0,1-.72,1.11,3.92,3.92,0,0,1-1,.83A2.12,2.12,0,0,1,332.1,166.74Zm1.72-2a1.68,1.68,0,0,0,.29-.9.54.54,0,0,0-.29-.55.87.87,0,0,0-.73.14,2,2,0,0,0-.71.69,1.63,1.63,0,0,0-.3.89c0,.3.1.48.3.56a.85.85,0,0,0,.71-.13A2.21,2.21,0,0,0,333.82,164.76Z",
    style: {
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M265.72,138.86c0-.91-.64-1.28-1.43-.82l-13.17,7.61a3.18,3.18,0,0,0-1.43,2.49V158.8c0,.91.64,1.28,1.43.82L256,156.8l2.06,3.55a.3.3,0,0,0,.55,0l2.17-6.26h0l3.51-2a3.14,3.14,0,0,0,1.43-2.48Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M254.25,150a.89.89,0,0,1-.71-.28,1.31,1.31,0,0,1-.26-.87,3,3,0,0,1,.26-1.18,4.36,4.36,0,0,1,.71-1.11,4.1,4.1,0,0,1,1-.84,2.09,2.09,0,0,1,1-.31.88.88,0,0,1,.72.29,1.26,1.26,0,0,1,.27.87,2.88,2.88,0,0,1-.27,1.17,4.64,4.64,0,0,1-.72,1.12,4,4,0,0,1-1,.82A2,2,0,0,1,254.25,150Zm-.32,5.39a.32.32,0,0,1,.06-.18l5.72-11.64a1.5,1.5,0,0,1,.15-.26.69.69,0,0,1,.2-.17l1.18-.67a.17.17,0,0,1,.14,0s.05,0,.05.09a.34.34,0,0,1-.05.19l-5.75,11.69a1.27,1.27,0,0,1-.13.22.47.47,0,0,1-.18.14l-1.19.69C254,155.56,253.93,155.54,253.93,155.42Zm2-7.38a1.64,1.64,0,0,0,.29-.88.55.55,0,0,0-.29-.57.81.81,0,0,0-.72.13,2.07,2.07,0,0,0-.71.7,1.6,1.6,0,0,0-.29.9c0,.29.09.47.29.55a.79.79,0,0,0,.71-.13A2,2,0,0,0,256,148Zm3.18,4.48a.88.88,0,0,1-.72-.29,1.28,1.28,0,0,1-.26-.86,3,3,0,0,1,.26-1.16,4.28,4.28,0,0,1,.72-1.12,3.84,3.84,0,0,1,1-.83,2,2,0,0,1,1-.32.94.94,0,0,1,.72.28,1.24,1.24,0,0,1,.26.87,2.82,2.82,0,0,1-.26,1.17,4.64,4.64,0,0,1-.72,1.12,4.09,4.09,0,0,1-1,.83A2.09,2.09,0,0,1,259.15,152.52Zm1.72-2a1.67,1.67,0,0,0,.29-.89.53.53,0,0,0-.29-.55.82.82,0,0,0-.73.13,2,2,0,0,0-.71.7,1.6,1.6,0,0,0-.3.88c0,.3.1.49.3.56a.85.85,0,0,0,.71-.13A2.21,2.21,0,0,0,260.87,150.54Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M254.25,150a.89.89,0,0,1-.71-.28,1.31,1.31,0,0,1-.26-.87,3,3,0,0,1,.26-1.18,4.36,4.36,0,0,1,.71-1.11,4.1,4.1,0,0,1,1-.84,2.09,2.09,0,0,1,1-.31.88.88,0,0,1,.72.29,1.26,1.26,0,0,1,.27.87,2.88,2.88,0,0,1-.27,1.17,4.64,4.64,0,0,1-.72,1.12,4,4,0,0,1-1,.82A2,2,0,0,1,254.25,150Zm-.32,5.39a.32.32,0,0,1,.06-.18l5.72-11.64a1.5,1.5,0,0,1,.15-.26.69.69,0,0,1,.2-.17l1.18-.67a.17.17,0,0,1,.14,0s.05,0,.05.09a.34.34,0,0,1-.05.19l-5.75,11.69a1.27,1.27,0,0,1-.13.22.47.47,0,0,1-.18.14l-1.19.69C254,155.56,253.93,155.54,253.93,155.42Zm2-7.38a1.64,1.64,0,0,0,.29-.88.55.55,0,0,0-.29-.57.81.81,0,0,0-.72.13,2.07,2.07,0,0,0-.71.7,1.6,1.6,0,0,0-.29.9c0,.29.09.47.29.55a.79.79,0,0,0,.71-.13A2,2,0,0,0,256,148Zm3.18,4.48a.88.88,0,0,1-.72-.29,1.28,1.28,0,0,1-.26-.86,3,3,0,0,1,.26-1.16,4.28,4.28,0,0,1,.72-1.12,3.84,3.84,0,0,1,1-.83,2,2,0,0,1,1-.32.94.94,0,0,1,.72.28,1.24,1.24,0,0,1,.26.87,2.82,2.82,0,0,1-.26,1.17,4.64,4.64,0,0,1-.72,1.12,4.09,4.09,0,0,1-1,.83A2.09,2.09,0,0,1,259.15,152.52Zm1.72-2a1.67,1.67,0,0,0,.29-.89.53.53,0,0,0-.29-.55.82.82,0,0,0-.73.13,2,2,0,0,0-.71.7,1.6,1.6,0,0,0-.3.88c0,.3.1.49.3.56a.85.85,0,0,0,.71-.13A2.21,2.21,0,0,0,260.87,150.54Z",
    style: {
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.91,195.62c0-.91-.64-1.28-1.43-.83l-13.17,7.62a3.18,3.18,0,0,0-1.43,2.49v10.65c0,.92.64,1.29,1.43.83l4.89-2.82,2.05,3.55a.31.31,0,0,0,.56-.05l2.17-6.27h0l3.5-2a3.16,3.16,0,0,0,1.43-2.48Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.45,206.79a.85.85,0,0,1-.71-.29,1.21,1.21,0,0,1-.26-.86,2.83,2.83,0,0,1,.26-1.18,4.32,4.32,0,0,1,.71-1.12,3.92,3.92,0,0,1,1-.83,2,2,0,0,1,1-.31.88.88,0,0,1,.72.29,1.24,1.24,0,0,1,.27.87,2.83,2.83,0,0,1-.27,1.16,4.51,4.51,0,0,1-.72,1.13,4,4,0,0,1-1,.82A2.07,2.07,0,0,1,206.45,206.79Zm-.32,5.39a.49.49,0,0,1,.05-.19l5.72-11.63a1.19,1.19,0,0,1,.15-.26.85.85,0,0,1,.2-.17l1.18-.68a.21.21,0,0,1,.14,0,.08.08,0,0,1,.06.09.38.38,0,0,1-.06.19l-5.74,11.69c-.05.1-.1.17-.13.22a.84.84,0,0,1-.19.14l-1.19.69C206.19,212.31,206.13,212.3,206.13,212.18Zm2-7.38a1.65,1.65,0,0,0,.28-.88c0-.3-.09-.49-.28-.57a.81.81,0,0,0-.72.13,2,2,0,0,0-.72.7,1.68,1.68,0,0,0-.29.9.53.53,0,0,0,.29.55.81.81,0,0,0,.72-.13A2.09,2.09,0,0,0,208.17,204.8Zm3.18,4.48a.91.91,0,0,1-.72-.29,1.25,1.25,0,0,1-.27-.86,2.83,2.83,0,0,1,.27-1.16,4.51,4.51,0,0,1,.72-1.13,4.15,4.15,0,0,1,1-.82,2.07,2.07,0,0,1,1-.32.91.91,0,0,1,.72.28,1.23,1.23,0,0,1,.27.87,2.84,2.84,0,0,1-.27,1.17,4.4,4.4,0,0,1-.72,1.11,3.72,3.72,0,0,1-1,.83A2,2,0,0,1,211.35,209.28Zm1.71-2a1.68,1.68,0,0,0,.29-.9.54.54,0,0,0-.29-.55.87.87,0,0,0-.73.14,2.12,2.12,0,0,0-.71.69,1.64,1.64,0,0,0-.29.89c0,.3.09.48.29.56a.85.85,0,0,0,.71-.13A2.21,2.21,0,0,0,213.06,207.3Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.45,206.79a.85.85,0,0,1-.71-.29,1.21,1.21,0,0,1-.26-.86,2.83,2.83,0,0,1,.26-1.18,4.32,4.32,0,0,1,.71-1.12,3.92,3.92,0,0,1,1-.83,2,2,0,0,1,1-.31.88.88,0,0,1,.72.29,1.24,1.24,0,0,1,.27.87,2.83,2.83,0,0,1-.27,1.16,4.51,4.51,0,0,1-.72,1.13,4,4,0,0,1-1,.82A2.07,2.07,0,0,1,206.45,206.79Zm-.32,5.39a.49.49,0,0,1,.05-.19l5.72-11.63a1.19,1.19,0,0,1,.15-.26.85.85,0,0,1,.2-.17l1.18-.68a.21.21,0,0,1,.14,0,.08.08,0,0,1,.06.09.38.38,0,0,1-.06.19l-5.74,11.69c-.05.1-.1.17-.13.22a.84.84,0,0,1-.19.14l-1.19.69C206.19,212.31,206.13,212.3,206.13,212.18Zm2-7.38a1.65,1.65,0,0,0,.28-.88c0-.3-.09-.49-.28-.57a.81.81,0,0,0-.72.13,2,2,0,0,0-.72.7,1.68,1.68,0,0,0-.29.9.53.53,0,0,0,.29.55.81.81,0,0,0,.72-.13A2.09,2.09,0,0,0,208.17,204.8Zm3.18,4.48a.91.91,0,0,1-.72-.29,1.25,1.25,0,0,1-.27-.86,2.83,2.83,0,0,1,.27-1.16,4.51,4.51,0,0,1,.72-1.13,4.15,4.15,0,0,1,1-.82,2.07,2.07,0,0,1,1-.32.91.91,0,0,1,.72.28,1.23,1.23,0,0,1,.27.87,2.84,2.84,0,0,1-.27,1.17,4.4,4.4,0,0,1-.72,1.11,3.72,3.72,0,0,1-1,.83A2,2,0,0,1,211.35,209.28Zm1.71-2a1.68,1.68,0,0,0,.29-.9.54.54,0,0,0-.29-.55.87.87,0,0,0-.73.14,2.12,2.12,0,0,0-.71.69,1.64,1.64,0,0,0-.29.89c0,.3.09.48.29.56a.85.85,0,0,0,.71-.13A2.21,2.21,0,0,0,213.06,207.3Z",
    style: {
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.08,295.18l9.65-5.57c1.41-.81,2.54-.46,2.54.78a5,5,0,0,1-2.54,3.71l-9.64,5.57c-1.41.81-2.55.46-2.55-.78A5.06,5.06,0,0,1,206.08,295.18Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M254.07,267.47l9.65-5.57c1.4-.81,2.54-.46,2.54.78a5.06,5.06,0,0,1-2.54,3.71L254.07,272c-1.4.81-2.54.46-2.54-.78A5.08,5.08,0,0,1,254.07,267.47Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M290.74,246.33l9.65-5.57c1.4-.81,2.54-.46,2.54.78a5.06,5.06,0,0,1-2.54,3.71l-9.65,5.57c-1.4.81-2.54.47-2.54-.77A5.07,5.07,0,0,1,290.74,246.33Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M326.86,225.45l9.65-5.57c1.41-.81,2.55-.47,2.54.77a5,5,0,0,1-2.54,3.72l-9.64,5.57c-1.41.81-2.55.46-2.55-.78A5.06,5.06,0,0,1,326.86,225.45Z",
    style: {
      fill: "#f5f5f5"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Character--inject-161"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M394,170.67c-2.47-.18-5.9-.19-9.29,5.35s-12.6,20.78-12.6,20.78l6,4.06,10.5-14.75s1-11.79,2.94-13.44S394,170.67,394,170.67Z",
    style: {
      fill: "#f28f8f"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 397.87,
    y: 282.91,
    width: 5.92,
    height: 8.61,
    transform: "translate(-68.98 137.44) rotate(-17.94)",
    style: {
      fill: "#ffa8a7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M398.21,288.67a3.3,3.3,0,0,1-.49,1.91,23.9,23.9,0,0,1-3.15,4.14c-1.69,1.81-4.22,4-6,5.53-1,.88-1.05,2.21.39,2.67a10.79,10.79,0,0,0,7.91-1.1c1.8-1,4.36-5.42,5.85-6.1,1.72-.77,2.69-1.16,3.27-2a2.79,2.79,0,0,0,.35-3.45c-.81-1.51-2-3.83-2.53-3.57l.15.47c-.39,1.23-3.74,2.66-5.46,2.32Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M403.94,287.22c-1.59-.49-2.07.35-3.79,0l-1.94,1.45a3.22,3.22,0,0,1-.49,1.91,23.9,23.9,0,0,1-3.15,4.14c-.83.88-1.85,1.84-2.88,2.78h0c-.83,1.3,1.94,1.68,3.47,1.24a8.52,8.52,0,0,0,4.14-3.18c1.11-1.46,4.13-4.85,4.58-6A3.11,3.11,0,0,0,403.94,287.22Z",
    style: {
      fill: "#ffa8a7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M422.86,204.4c-.82-6-2.66-13-5.08-23.77-.87-3.89-2-7.4-4.78-8.48h0s-7.63,3.14-7.63,8.78,6.17,8.53,6.17,8.53l3.52,12.14,5.58,6.77A3.31,3.31,0,0,0,422.86,204.4Z",
    style: {
      fill: "#ffa8a7"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 405.19,
    y: 295.58,
    width: 5.75,
    height: 8.37,
    style: {
      fill: "#ffa8a7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M415.27,210.26c2.28,9.76.06,22.93-.72,31.14-.76,8-1.7,17.35-1.7,17.35s2.45,8.45,2.33,15c-.12,6.92-4.17,23.58-4.17,23.58a5.45,5.45,0,0,1-5.9,0s-1-14-2-21.92c-1-8.3-1.32-14.34-2.17-19.19-1.07-6-2.86-31.58-2.86-31.58L395,250a40.5,40.5,0,0,1,4.28,9.72c1.26,4.91,4,24.4,4,24.4a9.69,9.69,0,0,1-6.22,2.47s-12.32-29.27-14-32.19c-1.8-3.11-2.07-37.17.8-45.7Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M404.74,170.8s7.28.91,8.26,1.35c-7.63,5.37-1.46,17.31-1.46,17.31l-3.69,10.17,7.41,10.6c-2.13,2.46-15.68,11-30.22,1.64a132.13,132.13,0,0,1,1.71-14.73c-2.1-10-2.32-13.19-1.71-15.54,1.71-6.61,5.62-10.83,10.11-11.08Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M404.74,170.8s7.28.91,8.26,1.35c-7.63,5.37-1.46,17.31-1.46,17.31l-3.69,10.17,7.41,10.6c-2.13,2.46-15.68,11-30.22,1.64a132.13,132.13,0,0,1,1.71-14.73c-2.1-10-2.32-13.19-1.71-15.54,1.71-6.61,5.62-10.83,10.11-11.08Z",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "367.86 188.69 392.66 195.23 399.98 226.01 376.4 219.16 367.86 188.69",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M378.67,209.06c-.23.63-1.58,2.37-4.47,2.24l-.36-1.28Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M378.67,209.06c-.23.63-1.58,2.37-4.47,2.24l-.36-1.28Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M384.22,210c.1.82,1.79,2.34,4.64,3.29,3.25,1.09,8.22.51,8.22.51l-.44-1.53Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M384.22,210c.1.82,1.79,2.34,4.64,3.29,3.25,1.09,8.22.51,8.22.51l-.44-1.53Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M375.12,193.15l-.2-.94c-.12-.53,1.34-.55,3.25-.06l3.65.95c1.91.5,3.55,1.32,3.66,1.84l.21.95Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M375.12,193.15l-.2-.94c-.12-.53,1.34-.55,3.25-.06l3.65.95c1.91.5,3.55,1.32,3.66,1.84l.21.95Z",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M373.4,189.58c-.07-.32.52-.41,1.32-.19l1.45.4s-.44-2,2.78-1.33a5,5,0,0,1,3.91,3l1.54.44c.86.24,1.63.7,1.73,1l.18.59-12.77-3.36S373.47,189.91,373.4,189.58Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M375.16,190.6c1.17.29,1.66.44,1.83,1.25s.28,1.59.28,1.59l5.66,1.5s-.27-1.17-.36-1.62.1-.73,1-.49l.08-.36-8.86-2.26Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M375,193.24s-.09-.42-.21-1,1.34-.54,3.25,0l3.66.95c1.91.5,3.54,1.32,3.66,1.84l.2.95Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M420.64,208.37l-5.58-6.77s-12.56,5.27-14.54,5.42-3.51-1.79-4.27-3.72-2.26-1.69-2.26-1.69.59,2.45.77,3.24-4.35,1.42-7,.53-6.42.4-4.06,4,6.92,4,10.1,4a33.46,33.46,0,0,0,4-.27c1-.13,2-.24,3.09-.31C407.38,212.3,417.68,209.29,420.64,208.37Z",
    style: {
      fill: "#ffa8a7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M370.38,197.69l1.1,3.93c.22.75,3.1,2.13,4.92,2.63s3.82,1.09,3,3.64c-.8,2.35-3.8,2.89-5.33,2.82s-3.61-1.52-4.44-3.88c-1-3-.48-6.2-.9-8S369.47,196.65,370.38,197.69Z",
    style: {
      fill: "#ffa8a7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M405.19,301.12v-.83a15.94,15.94,0,0,1-4.11,7.2c-1.82,1.66-4.29,3.57-4.92,5.41s2.92,2.68,5.27,2.45a9.53,9.53,0,0,0,5.9-3.09c1.49-1.71,1.46-2.88,2.16-3.82s2.3-2,2.68-3.09a6.92,6.92,0,0,0-.33-3c-.27-1-.56-2.13-.9-2v.63a4.59,4.59,0,0,1-2.88,1C407.22,301.93,405.18,301.76,405.19,301.12Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M410.94,300.92c-.42.46-.63-.67-1.93-.63-.84,0-2.25.64-2.25,0h-1.57a15.94,15.94,0,0,1-4.11,7.2c-.44.4-.91.81-1.39,1.23-1,1.08-.69,2,1.58,2.21s4.26-1.17,6-3.28A37.15,37.15,0,0,0,410.94,300.92Z",
    style: {
      fill: "#ffa8a7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M398.48,140.33h1.36a13.1,13.1,0,0,1,13.1,13.1v1.33a11.13,11.13,0,0,1-11.13,11.13h-5.36a11.13,11.13,0,0,1-11.13-11.13V153.5A13.17,13.17,0,0,1,398.48,140.33Z",
    transform: "translate(798.24 306.21) rotate(180)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M389.84,145.91c-1.46.86-3.26,4.53-3.08,12.22.15,6.52,2.26,8.13,3.32,8.6s3.11.18,5.1-.15v3.91s-2.75,3.2-2.57,5,4,2.22,6.54.46a20.83,20.83,0,0,0,4.74-5.16l-.05-9s1.17,1.14,3.16-.6c1.64-1.43,2.19-3.85.91-5.14a2.85,2.85,0,0,0-4.54.9,15.7,15.7,0,0,1-7.4-2.2A11.93,11.93,0,0,1,389.84,145.91Z",
    style: {
      fill: "#ffa8a7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M394,156.5a.83.83,0,0,0,.77.89.85.85,0,0,0,.87-.82.82.82,0,1,0-1.64-.07Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M393.82,162l-1.9.61a1,1,0,0,0,1.23.68A1,1,0,0,0,393.82,162Z",
    style: {
      fill: "#f28f8f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M387.32,154l1.66-1.15a1,1,0,0,0-1.38-.28A1,1,0,0,0,387.32,154Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M387.7,155.9a.82.82,0,1,0,.86-.81A.83.83,0,0,0,387.7,155.9Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "391.57 155.44 391.44 160.37 388.84 159.56 391.57 155.44",
    style: {
      fill: "#f28f8f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M395.18,166.58c2.1-.28,6.41-1.52,7.08-3.22a4.41,4.41,0,0,1-1.51,2.18c-1.29,1.1-5.57,2.34-5.57,2.34Z",
    style: {
      fill: "#f28f8f"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "410.03 193.62 404.29 201.4 407.85 199.63 410.03 193.62",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "410.03 193.62 404.29 201.4 407.85 199.63 410.03 193.62",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStandValue);
export default __webpack_public_path__ + "static/media/standValue.ed9c3e5dbcf3e420225e91396f1e634b.svg";
export { ForwardRef as ReactComponent };